'use client';

import { use } from 'react';
import VerifyPage from '../verify/page';
import CertificateVerificationClient from './[certificate]/CertificateVerificationClient';

const isEvmAddress = (value: string) => /^0x[a-fA-F0-9]{40}$/.test(value);

export default function TenantVerificationLanding({
    params,
}: {
    params: Promise<{ tenantSlug: string }>;
}) {
    const { tenantSlug } = use(params);

    // Backwards compatibility: historically the app had a root dynamic route `/:contract`.
    // That conflicts with `/:tenantSlug` in Next.js, so we treat 0x... slugs as contracts.
    if (isEvmAddress(tenantSlug)) {
        return <CertificateVerificationClient contract={tenantSlug} />;
    }

    return <VerifyPage />;
}
